import { __decorate } from "tslib";
import ImageComponent from '../../Component/components/ImageComponent';
import '../../editor.store';
import { declareComponents } from '../../modules';
import './DeleteImage.svelte';
import FlipImage from './FlipImage.svelte';
import './ImageReplacementButton.svelte';
let ImageModule = class ImageModule {
    toolbarActions = [
        {
            component: FlipImage
        }
    ];
    onFocus = (component) => {
        if (component.style) {
            try {
                // component.style.objectFit = 'contain';
            }
            catch (err) {
                console.warn('Problem with component style', err);
            }
        }
    };
};
ImageModule = __decorate([
    declareComponents([ImageComponent])
], ImageModule);
export default ImageModule;
